import EasyTrans from "../bundel/EasyTrans";
import HelpIcon from "./HelpIcon";
import React from "react";
import { TextField } from "../ui";

const WorkCreatorForm = (props) => {
  const creator = props.currentContributor;

  function setNewVal(key, newValue) {
    const map = {
      firstname: "firstName",
      lastname: "lastName",
      email: "email",
      pseudonym: "pseudonym",
      url: "url",
      percent: "percentage",
    };
    if (map[key]) props.currentContributor[map[key]] = newValue;
  }

  const help = (title, message, transKey) =>
    props.noHelpNeeded ? null : (
      <HelpIcon Title={title} Message={message} TransKey={transKey} />
    );

  return (
    <div
      className={
        props.creatorError ? "rounded-lg bg-red-50 p-3" : ""
      }
    >
      <div className="space-y-4">
        <TextField
          id="email"
          name="email"
          type="email"
          required
          label={<EasyTrans>RegisterWork.WorkCreator.EMail</EasyTrans>}
          labelAddon={help(
            "RegisterWork.WorkCreator.EMail",
            "",
            "RegisterWork.WorkCreator.HelpEMail",
          )}
          defaultValue={creator.email}
          onChange={(e) => setNewVal("email", e.target.value)}
          onFocus={() => props.setEmailError(false)}
          error={props.emailError}
          disabled={props.edit}
        />

        <div className="grid gap-4 sm:grid-cols-2">
          <TextField
            id="firstname"
            name="firstname"
            required
            label={<EasyTrans>RegisterWork.WorkCreator.FirstName</EasyTrans>}
            labelAddon={help(
              "RegisterWork.WorkCreator.FirstName",
              "",
              "RegisterWork.WorkCreator.HelpFirstName",
            )}
            defaultValue={creator.firstName}
            onChange={(e) => setNewVal("firstname", e.target.value)}
            onFocus={() => props.setFirstnameError(false)}
            error={props.firstnameError}
            disabled={props.edit}
          />
          <TextField
            id="lastname"
            name="lastname"
            required
            label={<EasyTrans>RegisterWork.WorkCreator.LastName</EasyTrans>}
            labelAddon={help(
              "RegisterWork.WorkCreator.LastName",
              "",
              "RegisterWork.WorkCreator.HelpLastName",
            )}
            defaultValue={creator.lastName}
            onChange={(e) => setNewVal("lastname", e.target.value)}
            onFocus={() => props.setLastnameError(false)}
            error={props.lastnameError}
            disabled={props.edit}
          />
        </div>

        <div className="grid gap-4 sm:grid-cols-2">
          <div>
            <div className="flex items-center pr-2">
              <label
                htmlFor="percent"
                className="block text-sm font-medium text-gray-700"
              >
                <EasyTrans>RegisterWork.WorkCreator.PercentTitle</EasyTrans>
                <span className="text-red-600">*</span>
              </label>
              {help(
                "RegisterWork.WorkCreator.PercentTitle",
                "Wie viel Prozent hat der Mitwirkende sich beteiligt am Werk?",
                "RegisterWork.WorkCreator.HelpPercent",
              )}
            </div>
            <div className="mt-3 flex items-center gap-3">
              <input
                id="percent"
                type="range"
                min={0}
                max={100}
                value={Number(creator.percentage) || 0}
                onChange={(e) => {
                  props.onPercentageChange(Number(e.target.value));
                  props.setPercentageError(false);
                }}
                className="h-2 flex-1 cursor-pointer accent-fairblue-500"
              />
              <span className="w-12 text-right text-sm font-semibold text-gray-900">
                {Number(creator.percentage) || 0}%
              </span>
            </div>
          </div>
          <TextField
            id="pseudonym"
            name="pseudonym"
            required
            label={<EasyTrans>RegisterWork.WorkCreator.Pseudonym</EasyTrans>}
            labelAddon={help(
              "RegisterWork.WorkCreator.Pseudonym",
              "Wenn ein Pseudonym eingetragen wird, wird dieses für die Veröffentlichung verwendet und nicht der Vor- und Nachname",
              "RegisterWork.WorkCreator.HelpPseudonym",
            )}
            defaultValue={creator.pseudonym}
            onChange={(e) => setNewVal("pseudonym", e.target.value)}
            onFocus={() => props.setPseudonymError(false)}
            error={props.pseudonymError}
            disabled={props.edit}
          />
        </div>

        <TextField
          id="url"
          name="url"
          label={<EasyTrans>RegisterWork.WorkCreator.URL</EasyTrans>}
          labelAddon={help(
            "RegisterWork.WorkCreator.URL",
            "URL (Uniform Resource Locator)",
            "RegisterWork.WorkCreator.HelpURL",
          )}
          defaultValue={creator.url}
          onChange={(e) => setNewVal("url", e.target.value)}
          disabled={props.edit}
        />
      </div>
    </div>
  );
};

export default WorkCreatorForm;
